import { render, staticRenderFns } from "./MemberManage.vue?vue&type=template&id=2a10a01c&scoped=true&"
import script from "./MemberManage.vue?vue&type=script&lang=js&"
export * from "./MemberManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a10a01c",
  null
  
)

export default component.exports